export const checkboxFields = ["noShowFee", "xray", "followUpReferral"];

export const checkboxes = [
  {
    name: "noShowFee",
    label:
      "If I miss my booked appointment without cancelling at least 2 hours in advance, I will be charged a $75 no-show fee.",
  },
  {
    name: "xray",
    label:
      "X-Ray requisitions from other clinics do NOT require an appointment. A $75 late-cancellation fee applies if not cancelled at least 2 hours in advance.",
  },
  {
    name: "followUpReferral",
    label:
      "Follow-up and referral appointments must be booked by phone. Online bookings for these appointment types may be cancelled or rescheduled.",
  },
];
